<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="delete">
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="webApplicationFirewallDelmodal = true"
            v-hasPermission="['monitor:WebApplicationFirewallMonitor:delete']"
            >{{ $t("alarms.common.delete") }}</Button
          >
        </span>
        <Button
          type="info"
          size="small"
          @click="rowClick(row)"
          v-hasPermission="['monitor:WebApplicationFirewallMonitor:detail']"
          >{{ $t("alarms.common.details") }}</Button
        >
      </template>
    </Table>
    <!-- 删除模式框 -->
    <Modal
      v-model="webApplicationFirewallDelmodal"
      width="360"
      :mask-closable="false"
    >
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ webApplicationFirewallName }}
          {{ $t("alarms.common.allWarningRules") }} ？
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removewebApplicationFirewall()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDateVue = {};
export default {
  name: "TablewebApplicationFirewall",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      webApplicationFirewallDelmodal: false,
      isDisable: false,
      modal_loading: false,
      val: "",
      webApplicationFirewallName: "",
      columns: [
        {
          title: this.$t("alarms.WebApplicationFirewall.accountIdString"),
          width: 150,
          key: "accountIdString"
        },
        {
          title: this.$t("alarms.WebApplicationFirewall.accountName"),
          width: 150,
          key: "accountName"
        },
        {
          title: this.$t("alarms.WebApplicationFirewall.region"),
          width: 150,
          key: "region"
        },
        {
          title: this.$t("alarms.WebApplicationFirewall.instanceId"),
          width: 150,
          key: "instanceId"
        },
        {
          title: this.$t("alarms.WebApplicationFirewall.statusName"),
          width: 150,
          key: "statusName"
        },
        {
          title: this.$t("alarms.WebApplicationFirewall.versionName"),
          key: "versionName"
        },
        {
          title: this.$t("common.operation"),
          width: 150,
          slot: "delete"
        }
      ],
      tableDate: []
    };
  },
  beforeCreate: function() {
    tableDateVue = this;
  },
  created() {
    eventBus.$on("companyId", function(val) {
      tableDateVue.companyId = val;
    });
    eventBus.$on("accountName", function(val) {
      tableDateVue.accountName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableDateVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function() {
      //列表分页
      this.$api.webApplicationFirewall
        .pageWebApplicationFirewall({
          pageNum: this.current,
          pageSize: this.pageSize,
          accountName: tableDateVue.accountName,
          companyId: tableDateVue.companyId
        })
        .then(res => {
          this.tableDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableDateVue.getData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableDateVue.getData();
    },
    // 销毁regionName
    beforeDestroy: function() {
      eventBus.$off("regionName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.webApplicationFirewallName = this.tableDate[index].accountName;
    },
    removewebApplicationFirewall: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //删除
      this.$api.webApplicationFirewall
        .delete("id", this.tableDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableDateVue.getData();
            this.isDisable = false;
            this.modal_loading = false;
            this.webApplicationFirewallDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 单击行
    /****************************************************/
    rowClick: function(row) {
      this.$router.push({
        path: "/monitor/WebApplicationFirewallDetail/",
        query: {
          instanceId: row.instanceId,
          accountId: row.accountId,
          region: row.region,
          accountName: row.accountName
        }
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/webApplicationFirewall/TableWebApplicationFirewall.vue